import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ClientUpdateDocumentModel } from 'src/app/models/archive/client-update-document.model';
import { ClientModel } from 'src/app/models/archive/client.model';
import { ClientService } from 'src/app/services/archive/client.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-update-document-client',
  templateUrl: './update-document-client.component.html',
  styleUrls: ['./update-document-client.component.scss'],
  standalone: false
})
export class UpdateDocumentClientComponent implements OnInit {

  btnDisabled: boolean = false;
  changeDocument: boolean = false;
  clientId: number = 0;
  clientContract: ClientModel = new ClientModel();
  formClient: FormGroup = new FormGroup({});
  suscription: Subscription;

  constructor(private clientService: ClientService,
    public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
    this.validateForm();
  }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.btnDisabled = inputs.btnDisabled;
      this.clientId = inputs.clientId;
    });
    await this.getClientById();
  }

  close() {
    const data: ModalObjectType = {};
    if (this.changeDocument) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  async getClientById() {
    try {
      this.clientContract = await firstValueFrom(this.clientService.getClientById(this.clientId));
      this.validateForm();
    } catch (error) {
      console.error('Error al buscar el cliente por ID.', error);
    }
  }

  async getDigitVerification() {
    const document = this.formClient.get("document")?.value;
    if (document == "") {
      this.formClient.controls["digitVerification"].setValue(-1);
      this.toastHandlerService.showToast(
        'error',
        'El documento ingresado no es válido.'
      );
      return;
    }
    try {
      const response = await firstValueFrom(this.clientService.getDigitVerification(document));
      this.formClient.controls["digitVerification"].setValue(response);
    } catch (error) {
      console.error("Error getting verification digit.", error);
      this.formClient.controls["digitVerification"].setValue(-1);
    }
  }

  async getDigitVerification2() {
    const document2 = this.formClient.get("document2")?.value;
    if (document2 == "") {
      this.formClient.controls["document2"].setValue(null);
      this.formClient.controls["digitVerification2"].setValue(null);
      return;
    }
    try {
      const response = await firstValueFrom(this.clientService.getDigitVerification(document2));
      this.formClient.controls["digitVerification2"].setValue(response);
    } catch (error) {
      console.error("Error getting verification digit.", error);
      this.formClient.controls["digitVerification2"].setValue(-1);
    }
  }

  async send() {
    this.formClient.enable();
    if (this.formClient.valid) {
      const modelClient = this.formClient.value as ClientUpdateDocumentModel;
      if (modelClient.document2 == "") modelClient.document2 = null;
      try {
        this.clientContract = await firstValueFrom(this.clientService.updateClientDocument(modelClient));
        this.toastHandlerService.showToast(
          'success',
          'Los documentos del cliente fueron modificados exitosamente.'
        );
        this.validateForm();
        this.changeDocument = true;
        this.close();
      } catch (error) {
        console.error("Error al actualizar los documentos del cliente.", error);
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Todos los campos marcados con (*) son obligatorios.'
      );
    }
  }

  validateForm() {
    this.formClient = this.formBuilder.group({
      clientId: [this.clientContract.clientId, [Validators.required, Validators.min(1)]],
      document: [this.clientContract.document, [Validators.required, Validators.maxLength(15)]],
      digitVerification: [this.clientContract.digitVerification, [Validators.required, Validators.min(0), Validators.max(9)]],
      document2: [this.clientContract.document2, [Validators.maxLength(15)]],
      digitVerification2: [this.clientContract.digitVerification2, [Validators.min(0), Validators.max(9)]]
    });
    setTimeout(() => this.formClient.controls["digitVerification"].disable(), 100);
    setTimeout(() => this.formClient.controls["digitVerification2"].disable(), 100);
  }
}
